export const IS_MARKETPLACE = process.env.VUE_APP_MARKETPLACE === 'true'
export const IS_DASHBOARD = process.env.VUE_APP_DASHBOARD === 'true'
export const IS_ADMIN = process.env.VUE_APP_ADMIN === 'true'
export const IS_ELITEPAGE = process.env.VUE_APP_ELITEPAGE === 'true'
export const IS_EMBED = process.env.VUE_APP_EMBED === 'true'

export const ENV_IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const ENV_IS_STAGING = process.env.NODE_ENV === 'staging'
export const ENV_IS_PRODUCTION = process.env.NODE_ENV === 'production'
